import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const auth = async (token) => {
    return axios.post(`${BACKEND_URL}/auth`, token);
};

export const changePassword = async (email, passwordLink, password) =>{
    return axios.put(`${BACKEND_URL}/profiles/${email}/${passwordLink}/password`, {password: password});
};

export const login = async (login) => {
    return axios.post(`${BACKEND_URL}/login`, login);
};

export const register = async (data) => {
    return axios.post(`${BACKEND_URL}/register`, data);
};

export const renew = async (data) => {
    return axios.post(`${BACKEND_URL}/renew`, data);
};